export const ON_SOCIAL_CHANGE = '@ARI/Questionnaire/Social/ON_SOCIAL_CHANGE';
export const ON_SOCIAL_BLUR = '@ARI/Questionnaire/Social/ON_SOCIAL_BLUR';
export const SET_SOCIAL_VALIDATORS = '@ARI/Questionnaire/Social/SET_SOCIAL_VALIDATORS';
export const SET_SOCIAL_VALUES = '@ARI/Questionnaire/Social/SET_SOCIAL_VALUES';
export const SET_SOCIAL_SETTINGS = '@ARI/Questionnaire/Social/SET_SOCIAL_SETTINGS';
export const SET_SOCIAL_ERRORS = '@ARI/Questionnaire/Social/SET_SOCIAL_ERRORS';